import React, { useEffect, useState } from "react";
import { IconNotVerified, IconVerified } from "../../components/icons";
import { Form, Button, Input } from "antd";
import {
  unverifyPhone,
  verificationRequestPhone,
  verifyPhone,
} from "../../api";
import { VERIFICATION } from "../../constants";
import EnterOtp from "../../components/common/EnterOtp";
import { commonUtil } from "../../utils";
import { useTranslation } from "react-i18next";
import { ValidationForm } from "../../common/interfaces";
import ReCAPTCHA from "react-google-recaptcha";

interface Props {
  reload: Function;
  identifier: any;
  canUnlink: boolean;
}

const UpdatePhone: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation(["common", "notification"]);
  const [verificationId, setVerificationId] = useState<number>(0);
  const [phone, setPhone] = useState<string>("");
  const [showEnterOtp, setShowEnterOtp] = useState<boolean>(false);
  const [validatePhone, setValidatePhone] = useState<ValidationForm | null>();
  const recaptchaRef: any = React.createRef();

  useEffect(() => {
    setPhone(props.identifier ? props.identifier.identifier_value : "");
  }, [props.identifier]);

  const onChange = (value: string) => {
    setPhone(value.trim());
    setValidatePhone(null);
  };

  const onClickGetOtp = async () => {
    if (!phone || !phone.trim()) {
      setValidatePhone({
        status: "error",
        text: t("notification:Vui lòng nhập số điện thoại"),
      });
      return;
    }
    if (!commonUtil.isPhoneValid(phone)) {
      setValidatePhone({
        status: "error",
        text: t("notification:Số điện thoại không đúng định dạng"),
      });
      return;
    }

    // @ts-ignore
    const token = await recaptchaRef.current.getValue();
    // @ts-ignore
    recaptchaRef.current.reset();
    setValidatePhone(null);

    if (!token || token == "") {
      setValidatePhone({
        status: "error",
        text: t("notification:Vui lòng chọn Tôi không phải người máy"),
      });
      return false;
    }

    const res = await verificationRequestPhone({
      feature: VERIFICATION.FEATURE.PROFILE_VERIFIED,
      phone: commonUtil.convertPhone(phone),
      token: token,
    });
    if (res.status === "error") {
      commonUtil.showMessage("error", res.message);
    } else {
      setVerificationId(res.data.verificationId);
      setShowEnterOtp(true);
    }
  };

  const renderActionButton = () => {
    if (!phone) {
      return null;
    }
    const convertedPhone = commonUtil.convertPhone(phone);
    if (!commonUtil.isPhoneValid(convertedPhone)) {
      return null;
    }
    if (
      props.identifier &&
      props.identifier.status === "verified" &&
      convertedPhone === props.identifier.identifier_value
    ) {
      return null;
    }
    return (
      <>
        <div style={{ marginTop: "10px" }}>
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6Ld_n7EZAAAAAMif3OxoZ1kvUvyBN3uXTXMTz4w7"
          />
        </div>
        {t("common:Số điện thoại này chưa được xác minh")}.&nbsp;
        <a onClick={onClickGetOtp} style={{ color: "#ef4343" }}>
          {t("common:Gửi mã xác thực")}
        </a>
      </>
    );
  };

  const onClickRemovePhone = async () => {
    const res = await unverifyPhone();
    if (res.status === "error") {
      commonUtil.showMessage("error", res.message);
      return;
    }
    props.reload();
  };

  const onConfirmOtpSuccess = async () => {
    const res = await verifyPhone({
      verificationId,
      phone: commonUtil.convertPhone(phone),
    });
    if (res.status === "error") {
      commonUtil.showMessage("error", res.message);
      return;
    }
    setShowEnterOtp(false);
    props.reload();
  };

  return (
    <>
      <Form.Item
        validateStatus={validatePhone?.status}
        help={validatePhone?.text}
        label={
          <div className="flex items-center gap-4">
            {t("common:Số điện thoại")}&nbsp;
            {props.identifier && props.identifier.status === "verified" ? (
              <IconVerified />
            ) : (
              <IconNotVerified />
            )}
          </div>
        }
      >
        <Input
          placeholder={t("common:Số điện thoại")}
          disabled={props.identifier && props.identifier.status === "verified"}
          value={phone}
          style={{
            backgroundColor: "white",
            color: "black",
          }}
          onChange={(event) => onChange(event.target.value)}
          suffix={
            props.identifier &&
            props.identifier.status === "verified" &&
            props.canUnlink ? (
              <span
                style={{ color: "#F5222D", cursor: "pointer" }}
                onClick={(e) => onClickRemovePhone()}
              >
                {t("common:Bỏ kết nối")}
              </span>
            ) : null
          }
        />
        {renderActionButton()}
      </Form.Item>
      {showEnterOtp ? (
        <EnterOtp
          verificationId={verificationId}
          type={"phone"}
          feature={VERIFICATION.FEATURE.PROFILE_VERIFIED}
          value={commonUtil.convertPhone(phone)}
          onClose={() => {
            setShowEnterOtp(false);
          }}
          onResend={(verificationId) => {
            setVerificationId(verificationId);
          }}
          onConfirmSuccess={onConfirmOtpSuccess}
        />
      ) : null}
    </>
  );
};

export default UpdatePhone;
